(async () => {
    const { Core } = await importModule('Core');

    customElements.define('product-zoom', class extends Core {
        render() {
           var  product_image__zoom = this.closest(".product_image__zoom");

            if(product_image__zoom) {
        var imagesArr = product_image__zoom.querySelectorAll('.image-type-media img');
        if(imagesArr.length) {
          imagesArr.forEach(function (item,index) {
            item.addEventListener('click', function (e) {
              e.preventDefault();

              var pswpElement = document.querySelectorAll('.pswp')[0];

              var items = [];
              imagesArr.forEach(function (imageEl,index) {
                var imageObj = {
                  src: imageEl.getAttribute('data-image-url'),
                  w: +(imageEl.getAttribute('data-image-width')),
                  h: +(imageEl.getAttribute('data-image-height')),
                  title: (imageEl.getAttribute('alt'))
                }
                items.push(imageObj);
              });

              var options = {
                index: index // start at first slide
              };
              var pswpElement = document.querySelectorAll('.pswp')[0];
              var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
              gallery.init();
            });
          });
        }

      }
        }
    })
})()